module.exports = __webpack_public_path__ + "static/img/fawarehouse_40x44.2414ffa5.svg";